import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ProductCategory from "@/components/products/ProductCategory/ProductCategory";
import "./CategoryPage.css";
const CategoryPage = () => {
    return (_jsx("div", { className: "main-container", children: _jsx(ProductCategory, {}) }));
};
export default CategoryPage;
